import moment from "moment";
import { getEvents } from "../../apis";
import { RECOMMENDATION } from "../../redux/actionTypes";
import { getMktSegIdFromMappedMktSegId } from "../../utils/global_functions";
import { API_RESPONSE_STATUS } from "../../utils/global_variables";
import dayjs from "dayjs";

// Hari k:28-06-2024 : to set default date -start
const _findDate = (objects, startDate) => {
    const date = dayjs(startDate);
    const daysInMonth = date.daysInMonth();
    const startDay = date.date();
    if (objects?.length) {
        // Check from start date to the end of the month
        for (let day = startDay; day <= daysInMonth; day++) {
            const currentDate = date.date(day);
            // Create the date string in YYYY-MM-DD format
            const dateString = currentDate.format('DD-MMM-YYYY');
            // Check if this date is present in the objects array
            const found = objects.find(obj => obj.eventDate === dateString);
            if (found) {
                return dateString; // This stops the loop and returns the date
            }
        }

        // Check from start date backwards to the beginning of the month
        for (let day = startDay - 1; day >= 1; day--) {
            const currentDate = date.date(day);
            // Create the date string in YYYY-MM-DD format
            const dateString = currentDate.format('DD-MMM-YYYY');
            // Check if this date is present in the objects array
            const found = objects.find(obj => obj.eventDate === dateString);
            if (found) {
                return dateString;
            }
        }
    } else {
        return startDate;
    }

};
// Hari k:28-06-2024 : to set default date -end


async function _getEvents(strStartDate, strEndDate, strExhcangeType, strJtenantToken) {

    /* it's mainly gives the same key names for all the events categories to map the events by the time of showing in UI.*/
    /* strStart and trEndDate are passing as a parameter to get the events for particular time period */
    /* strExhcangeType is passing as a parameter to get the events for particular exchange */
    /*  strJtenantToken is a parameter to get events for particular tenent*/

    try {
        const objResp = await getEvents(strStartDate, strEndDate, strExhcangeType, strJtenantToken);

        if (objResp?.data?.ResponseObject?.type === API_RESPONSE_STATUS.SUCCESS) {
            let finalArr = [];
            objResp?.data?.ResponseObject?.resultset.forEach((item) => {
                switch (item.event) {
                    case "Book-Closure":
                        const newArr = item.data.map((eventObj) => {
                            let scripobj = eventObj.ScripData_NSE !== '-' ? eventObj.ScripData_NSE : eventObj.ScripData_BSE !== '-' ? eventObj.ScripData_BSE : '-';
                            let symbol = "";
                            if (scripobj !== "-") {
                                symbol = scripobj.Symbol;
                            }
                            return {
                                title: symbol === "" ? eventObj.co_name : symbol,
                                scripobj: scripobj,
                                eventDate: eventObj.StartDate,
                                nSegmentId: getMktSegIdFromMappedMktSegId(scripobj?.MarketSegmentId),
                                eventType: 'Book-Closure',
                                exchangeType: eventObj.ScripData_NSE !== '-' ? 'NSE' : eventObj.ScripData_BSE !== '-' ? "BSE" : ''
                            };
                        });
                        finalArr.push({ event: item.event, data: newArr });
                        break;
                    case "Change-of-Name":
                        const changeOfNameArr = item.data.map((eventObj) => {
                            let scripobj = eventObj.ScripData_NSE !== '-' ? eventObj.ScripData_NSE : eventObj.ScripData_BSE !== '-' ? eventObj.ScripData_BSE : '-';
                            let symbol = "";
                            if (scripobj !== "-") {
                                symbol = scripobj.Symbol;
                            }
                            return {
                                title: symbol === "" ? eventObj.OldName : symbol,
                                scripobj: scripobj,
                                eventDate: eventObj.SourceDate,
                                nSegmentId: getMktSegIdFromMappedMktSegId(scripobj?.MarketSegmentId),
                                exchangeType: eventObj.ScripData_NSE !== '-' ? 'NSE' : eventObj.ScripData_BSE !== '-' ? "BSE" : '',
                                eventType: 'Change-of-Name'
                            };
                        });
                        finalArr.push({ event: item.event, data: changeOfNameArr });
                        break;
                    case "Announcement":
                        const AnnouncementArr = item.data.map((eventObj) => {
                            let scripobj = eventObj.ScripData_NSE !== '-' ? eventObj.ScripData_NSE : eventObj.ScripData_BSE !== '-' ? eventObj.ScripData_BSE : '-';
                            let symbol = "";
                            if (scripobj !== "-") {
                                symbol = scripobj.Symbol;
                            }
                            return {
                                title: symbol === "" ? eventObj.CompanyLongName : symbol,
                                eventDate: eventObj.Date,
                                description: eventObj.Memo,
                                scripobj: scripobj,
                                caption: eventObj.Caption,
                                nSegmentId: getMktSegIdFromMappedMktSegId(scripobj?.MarketSegmentId),
                                exchangeType: eventObj.ScripData_NSE !== '-' ? 'NSE' : eventObj.ScripData_BSE !== '-' ? "BSE" : '',
                                eventType: 'Announcement'
                            };
                        });
                        finalArr.push({ event: item.event, data: AnnouncementArr });
                        break;
                    case "AGM":
                        const agmArr = item.data.map((eventObj) => {
                            let scripobj = eventObj.ScripData_NSE !== '-' ? eventObj.ScripData_NSE : eventObj.ScripData_BSE !== '-' ? eventObj.ScripData_BSE : '-';
                            let symbol = "";
                            if (scripobj !== "-") {
                                symbol = scripobj.Symbol;
                            }
                            return {
                                title: symbol === "" ? eventObj.co_name : symbol,
                                scripobj: scripobj,
                                eventDate: eventObj.gmdate,
                                description: eventObj.description,
                                nSegmentId: getMktSegIdFromMappedMktSegId(scripobj?.MarketSegmentId),
                                exchangeType: eventObj.ScripData_NSE !== '-' ? 'NSE' : eventObj.ScripData_BSE !== '-' ? "BSE" : '',
                                eventType: 'AGM'
                            };
                        });
                        finalArr.push({ event: item.event, data: agmArr });
                        break;
                    case "EGM":
                        const egmArr = item.data.map((eventObj) => {
                            let scripobj = eventObj.ScripData_NSE !== '-' ? eventObj.ScripData_NSE : eventObj.ScripData_BSE !== '-' ? eventObj.ScripData_BSE : '-';
                            let symbol = "";
                            if (scripobj !== "-") {
                                symbol = scripobj.Symbol;
                            }
                            return {
                                title: symbol === "" ? eventObj.co_name : symbol,
                                description: eventObj.description,
                                eventDate: eventObj.gmdate,
                                scripobj: scripobj,
                                nSegmentId: getMktSegIdFromMappedMktSegId(scripobj?.MarketSegmentId),
                                exchangeType: eventObj.ScripData_NSE !== '-' ? 'NSE' : eventObj.ScripData_BSE !== '-' ? "BSE" : '',
                                eventType: 'EGM'
                            };
                        });
                        finalArr.push({ event: item.event, data: egmArr });
                        break;
                    case "BoardMeeting":
                        const boardMeatingtArr = item.data.map((eventObj) => {
                            let scripobj = eventObj.ScripData_NSE !== '-' ? eventObj.ScripData_NSE : eventObj.ScripData_BSE !== '-' ? eventObj.ScripData_BSE : '-';
                            let symbol = "";
                            if (scripobj !== "-") {
                                symbol = scripobj.Symbol;
                            }
                            return {
                                title: symbol === "" ? eventObj.co_name : symbol,
                                description: eventObj.description,
                                eventDate: eventObj.bmdate,
                                scripobj: scripobj,
                                nSegmentId: getMktSegIdFromMappedMktSegId(scripobj?.MarketSegmentId),
                                exchangeType: eventObj.ScripData_NSE !== '-' ? 'NSE' : eventObj.ScripData_BSE !== '-' ? "BSE" : '',
                                eventType: 'BoardMeeting'
                            };
                        });
                        finalArr.push({ event: item.event, data: boardMeatingtArr });
                        break;
                    case "Split":
                        const splitArr = item.data.map((eventObj) => {
                            let scripobj = eventObj.ScripData_NSE !== '-' ? eventObj.ScripData_NSE : eventObj.ScripData_BSE !== '-' ? eventObj.ScripData_BSE : '-';
                            let symbol = "";
                            if (scripobj !== "-") {
                                symbol = scripobj.Symbol;
                            }
                            return {
                                title: symbol === "" ? eventObj.co_name : symbol,
                                scripobj: scripobj,
                                description: eventObj.description,
                                eventDate: eventObj.splitdate,
                                nSegmentId: getMktSegIdFromMappedMktSegId(scripobj?.MarketSegmentId),
                                exchangeType: eventObj.ScripData_NSE !== '-' ? 'NSE' : eventObj.ScripData_BSE !== '-' ? "BSE" : '',
                                eventType: 'Split'
                            };
                        });
                        finalArr.push({ event: item.event, data: splitArr });
                        break;
                    case "Bonus":
                        const bonustArr = item.data.map((eventObj) => {
                            let scripobj = eventObj.ScripData_NSE !== '-' ? eventObj.ScripData_NSE : eventObj.ScripData_BSE !== '-' ? eventObj.ScripData_BSE : '-';
                            let symbol = "";
                            if (scripobj !== "-") {
                                symbol = scripobj.Symbol;
                            }
                            return {
                                title: symbol === "" ? eventObj.co_name : symbol,
                                scripobj: scripobj,
                                description: eventObj.description,
                                eventDate: eventObj.bonusdate,
                                nSegmentId: getMktSegIdFromMappedMktSegId(scripobj?.MarketSegmentId),
                                exchangeType: eventObj.ScripData_NSE !== '-' ? 'NSE' : eventObj.ScripData_BSE !== '-' ? "BSE" : '',
                                eventType: 'Bonus'
                            };
                        });
                        finalArr.push({ event: item.event, data: bonustArr });
                        break;
                    case "Buy Back":
                        const buyBackArr = item.data.map((eventObj) => {
                            let scripobj = eventObj.ScripData_NSE !== '-' ? eventObj.ScripData_NSE : eventObj.ScripData_BSE !== '-' ? eventObj.ScripData_BSE : '-';
                            let symbol = "";
                            if (scripobj !== "-") {
                                symbol = scripobj.Symbol;
                            }
                            return {
                                title: symbol === "" ? eventObj.co_name : symbol,
                                description: eventObj.Description,
                                scripobj: scripobj,
                                eventDate: eventObj.startdate,
                                nSegmentId: getMktSegIdFromMappedMktSegId(scripobj?.MarketSegmentId),
                                exchangeType: eventObj.ScripData_NSE !== '-' ? 'NSE' : eventObj.ScripData_BSE !== '-' ? "BSE" : '',
                                eventType: 'Buy Back'
                            };
                        });
                        finalArr.push({ event: item.event, data: buyBackArr });
                        break;
                    case "Dividend":
                        const dividendtArr = item.data.map((eventObj) => {
                            let scripobj = eventObj.ScripData_NSE !== '-' ? eventObj.ScripData_NSE : eventObj.ScripData_BSE !== '-' ? eventObj.ScripData_BSE : '-';
                            let symbol = "";
                            if (scripobj !== "-") {
                                symbol = scripobj.Symbol;
                            }
                            return {
                                title: symbol === "" ? eventObj.co_name : symbol,
                                description: eventObj.description,
                                scripobj: scripobj,
                                eventDate: eventObj.recorddate,
                                nSegmentId: getMktSegIdFromMappedMktSegId(scripobj?.MarketSegmentId),
                                exchangeType: eventObj.ScripData_NSE !== '-' ? 'NSE' : eventObj.ScripData_BSE !== '-' ? "BSE" : '',
                                eventType: 'Dividend'
                            };
                        });
                        finalArr.push({ event: item.event, data: dividendtArr });
                        break;
                    case "ForthComing Results":
                        const forthComingResultArr = item.data.map((eventObj) => {
                            let scripobj = eventObj.ScripData_NSE !== '-' ? eventObj.ScripData_NSE : eventObj.ScripData_BSE !== '-' ? eventObj.ScripData_BSE : '-';
                            let symbol = "";
                            if (scripobj !== "-") {
                                symbol = scripobj.Symbol;
                            }
                            return {
                                title: symbol === "" ? eventObj.co_name : symbol,
                                scripobj: scripobj,
                                eventDate: eventObj.resultdate,
                                nSegmentId: getMktSegIdFromMappedMktSegId(scripobj?.MarketSegmentId),
                                exchangeType: eventObj.ScripData_NSE !== '-' ? 'NSE' : eventObj.ScripData_BSE !== '-' ? "BSE" : '',
                                eventType: 'ForthComing Results'
                            };
                        });
                        finalArr.push({ event: item.event, data: forthComingResultArr });
                        break;
                    case "Delisted Share":
                        const delistedSharesArr = item.data.map((eventObj) => {
                            let scripobj = eventObj.ScripData_NSE !== '-' ? eventObj.ScripData_NSE : eventObj.ScripData_BSE !== '-' ? eventObj.ScripData_BSE : '-';
                            let symbol = "";
                            if (scripobj !== "-") {
                                symbol = scripobj.Symbol;
                            }
                            return {
                                title: symbol === "" ? eventObj.CompanyName : symbol,
                                description: eventObj.Reason,
                                scripobj: scripobj,
                                eventDate: eventObj.DelistedDate,
                                nSegmentId: getMktSegIdFromMappedMktSegId(scripobj?.MarketSegmentId),
                                exchangeType: eventObj.ScripData_NSE !== '-' ? 'NSE' : eventObj.ScripData_BSE !== '-' ? "BSE" : '',
                                eventType: 'Delisted Share'
                            };
                        });
                        finalArr.push({ event: item.event, data: delistedSharesArr });
                        break;
                    default:
                        return null;
                }
            });
            const allEvents = { event: "ALL", data: [] }; // adding all category to show all the events under single tab
            finalArr.forEach((each) => {
                allEvents.data.push(...each.data);
            });
            finalArr.unshift(allEvents);
            return { status: true, message: RECOMMENDATION.GET_RECOMMENDATIONS_SUCCESS, data: finalArr };
        } else {
            return { status: false, message: RECOMMENDATION.GET_RECOMMENDATIONS_FAILURE };
        }

    } catch (error) {
        return { status: false, message: RECOMMENDATION.GET_RECOMMENDATIONS_FAILURE, error };
    }

}


const _getFormattedDate = (date, fontType) => {
    let formattedDate = '';
    const parsedDate = moment(date, 'DD-MMM-YYYY', true);
    const dayMonth = parsedDate.format('DD MMM');
    const year = parsedDate.format('\'YY');

    if (fontType) {
        return formattedDate = <div class={`font-medium font-size4 color-text`}>{dayMonth}<span class='font-regular font-size4 color-subtext ms-1'>{year}</span></div>;
    } else { }

    if (parsedDate?._isValid) {
        formattedDate = `${dayMonth}${year}`;
        return formattedDate;
    } else {
        return date;
    }
};


export { _getEvents, _getFormattedDate, _findDate }


